import { createFileRoute } from "@tanstack/react-router";
import { Logs } from "@/components/Logs";

export const Route = createFileRoute("/_authenticated/logs/")({
  component: Logs,
  staticData: { page: "logs" },
});
